export default __webpack_public_path__ + "static/296-2debc8c94d519184488cd6f712e28c00.gif";